import * as React from 'react'

const SvgEditIcon = (props) => (
  <svg
    width="26"
    height="26"
    viewBox="0 0 26 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="26" height="26" rx="13" fill="white" />
    <path
      d="M13 17.6666H18.25M7.75 17.6666H8.72682C9.01217 17.6666 9.15485 17.6666 9.28912 17.6344C9.40816 17.6058 9.52196 17.5587 9.62635 17.4947C9.74408 17.4226 9.84497 17.3217 10.0467 17.1199L17.375 9.79164C17.8583 9.30839 17.8583 8.52488 17.375 8.04164C16.8918 7.55839 16.1083 7.55839 15.625 8.04164L8.29674 15.3699C8.09496 15.5717 7.99407 15.6726 7.92192 15.7903C7.85795 15.8947 7.81081 16.0085 7.78224 16.1275C7.75 16.2618 7.75 16.4045 7.75 16.6898V17.6666Z"
      stroke="#98A2B3"
      strokeWidth="1.42857"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default SvgEditIcon
